import React, { useState, useEffect } from 'react';
import './WhatsAppWidget.css';
import { FaWhatsapp } from 'react-icons/fa';
import { db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

const WhatsAppWidget = () => {
  const [whatsappLink, setWhatsappLink] = useState('https://wa.me/573165248933'); // Default fallback

  useEffect(() => {
    const fetchLink = async () => {
      try {
        const docRef = doc(db, "siteSettings", "socialLinks");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data().whatsapp) {
          setWhatsappLink(docSnap.data().whatsapp);
        } else {
          console.log("No whatsapp link found, using default.");
        }
      } catch (error) {
        console.error("Error fetching whatsapp link:", error);
      }
    };

    fetchLink();
  }, []);

  return null; // Always return null to hide the widget
};

export default WhatsAppWidget;